/**
 * clears session storage
 */
export const clearSessionStorage = function () {
  if (sessionStorage !== undefined) {
    sessionStorage.clear();
  }
};

export const removeFromSessionStorage = function (key: string) {
  if (sessionStorage !== undefined) {
    sessionStorage.removeItem(key);
  }
};

/**
 * Read value from session storage
 * @param key
 * @returns
 */
export const getFromSessionStorage = function (key: string): any {
  if (sessionStorage !== undefined) {
    return sessionStorage.getItem(key);
  }
};

/**
 * Set value into session storage
 * @param key
 * @param value
 */
export const setInSessionStorage = function (key: string, value: any) {
  if (sessionStorage !== undefined) {
    if (value === 'string') {
      sessionStorage.setItem(key, value);
    } else {
      let stringifiedValue = JSON.stringify(value);
      sessionStorage.setItem(key, stringifiedValue);
    }
  }
};
